<template>
  <div class="facts">
    <breakfast-food v-if="company.breakfast_food || editable" v-bind="{ company, editable, breakfastFoods }" />
    <company-fact v-for="fact in company.facts" :editable="editable" :companyId="company.slug" :id="fact.id" :header="fact.header" :text="fact.text"></company-fact>
    <span class="small-icon-btn repeat-btn toggle-fun-fact" v-if="editable" @click="toggleForm"><span class="ss-icon is-big">plus</span><a class="add_fields">{{ I18n.t('create_your_own_question') }}</a></span>
    <form v-if="editable && showingForm" method="post" :action="`/companies/${company.slug}/facts`">
      <div class="field">
        <label class="cm-label" for="f_header">{{ I18n.t('question_title') }}</label>
        <div>
          <input type="text" name="fact[header]" class="cm-field val-required" id="f_header" required="true">
        </div>
      </div>
      <div class="field">
        <label class="cm-label" for="f_text">{{ I18n.t('your_answer') }}</label>
        <div>
          <input type="text" name="fact[text]" class="cm-field val-required" id="f_text" required="true">
        </div>
      </div>
      <footer>
        <input class="cm-button save-changes" type="submit" :value="I18n.t('save')">
      </footer>
    </form>
  </div>
</template>

<script>
  import CompanyFact from './fact'
  import BreakfastFood from './breakfast-food';

  export default {
    components: {CompanyFact, BreakfastFood},

    props: [
      'company',
      'editable',
      'breakfastFoods'
    ],

    data () {
      return {
        showingForm: false,
      }
    },

    methods: {
      toggleForm () {
        this.showingForm = !this.showingForm
      }
    }
  }
</script>

<style lang="scss" scoped>
  .facts {
    margin-bottom: $gutter;
  }

  label {
    font-weight: bold;
  }

  form {
    margin-top: 8px;
    font-size: $fs_large_body;
    width: 100%;
  }

  .delete-link {
    margin-bottom: $gutter;
    margin-top: $gutter / 2;
    font-size: $fs_small;
  }

  .cm-field {
    width: 100%;
    font-size: $fs_normal;
    margin-bottom: 15px;
  }

  .toggle-fun-fact {
    border-top: 1px solid var(--bg-2);
    cursor: pointer;
    display: block;
    padding-top: $gutter / 2;
    margin-top: $gutter / 2;
    margin-bottom: $gutter / 2;
  }
</style>



// WEBPACK FOOTER //
// app/javascript/company/facts.vue?225f8050